import { getIntlMessage } from '@/checkout-instore-legacy/i18n/utils'
import { useState } from 'react'
import { Dispatch } from 'redux'
import { openRootModalWithError } from '@/checkout-instore-legacy/rootModal/actions'
import { shouldPrintOnSameDevice } from '@/checkout-instore-legacy/utils/device/communication'
import {
  printPageCurrentDevice,
  printPageRemoteDevice,
} from '@/checkout-instore-legacy/utils/printUtils'

export function usePrintPage(dispatch: Dispatch<any>) {
  const [isLoading, setLoading] = useState(false)

  const printPage = async (timeToWait = 0) => {
    try {
      setLoading(true)
      shouldPrintOnSameDevice()
        ? await printPageCurrentDevice()
        : await printPageRemoteDevice(timeToWait)
    } catch (error) {
      dispatch(
        openRootModalWithError({
          errorTitle: getIntlMessage('print.failure.title'),
          error: getIntlMessage('print.failure.description'),
          onRetry: async () => await printPage(timeToWait),
          onGiveUp: () => undefined,
          onRetryText: undefined,
          onGiveUpText: undefined,
        })
      )
    } finally {
      setLoading(false)
    }
  }

  return {
    isLoading,
    printPage,
  }
}
